import { FC, ReactElement, useState } from 'react'
import { actions } from '@ecosystem/newron-design-system'
import { RootState } from 'reducers/store'
import { useSelector } from 'react-redux'
import { getSectionInfo } from 'reducers/tracking/selectors'
import { AnalyticsEvent, trackEvent, TRACKING } from 'util/analytics'
import PageTitleModal from 'components/Modal/PageTitleModal'
import * as styles from './index.module.scss'
import AIGradientIconWithText from 'components/AIGradientIcon'

interface Props {
  pageInfoTitle: string
  pageHintDescription: ReactElement
  pageInfoDescription: string
  hasAIGradientIcon?: boolean
}
export const PURCHASED_BRAND_ID = 14
export const PURCHASED_RETAILER_ID = 28
const KBQPagesInfo: FC<Props> = ({
  pageInfoTitle,
  pageHintDescription,
  pageInfoDescription,
  hasAIGradientIcon,
}) => {
  const { IconButton } = actions
  const { HelpOutline } = IconButton.icons
  const [showTitleTip, setShowTitleTip] = useState(false)
  const { section, pageName } = useSelector((state: RootState) => getSectionInfo(state))
  const handleTitleTipClick = () => {
    setShowTitleTip(true)
    trackEvent({
      id: AnalyticsEvent.PageElementClick,
      message: {
        access: TRACKING.ACCESS,
        elementCategory: TRACKING.HINT,
        elementName: TRACKING.HINT,
        pageName,
        section,
      },
    })
  }

  const handleModalClose = () => {
    setShowTitleTip(false)
  }

  return (
    <>
      {showTitleTip && (
        <PageTitleModal
          title={pageInfoTitle}
          content={pageHintDescription}
          onCloseClick={handleModalClose}
        />
      )}
      <div>
        <h1 className={styles.layoutTitle}>
          {pageInfoTitle}
          <div className="ml-3">
            <IconButton onClick={handleTitleTipClick}>
              <HelpOutline />
            </IconButton>
          </div>
        </h1>
        <span className={styles.pageInfoDescription}>
          {hasAIGradientIcon ? (
            <AIGradientIconWithText text="Verbatim powered by AI" />
          ) : (
            pageInfoDescription
          )}
        </span>
      </div>
    </>
  )
}

export default KBQPagesInfo
